import { useQuery } from '@tanstack/react-query';
import { getContactLeadsSummary } from '../api/contacts';

export function useContactLeadsSummary(contactId: string | null) {
  return useQuery({
    queryKey: ['contactLeadsSummary', contactId],
    queryFn: () => getContactLeadsSummary(contactId!),
    enabled: contactId != null && contactId !== '',
  });
}

